import { createRouter, createWebHistory } from "vue-router";
import { getAuth } from "firebase/auth";

const routes = [
    {
        path: "/moved",
        name: "Moved",
        component: () => import(/* webpackChunkName: "moved" */ "@/views/Moved"),
        meta: {
            requiresAuth: false,
            title: "We've moved to My Trips - Soca Islands",
        },
    },
    {
        path: "/",
        name: "Default",
        component: () => import(/* webpackChunkName: "bookings" */ "@/views/Bookings"),
        meta: {
            requiresAuth: true,
            title: "My Bookings - Soca Islands",
        },
    },
    {
        path: "/travel-dates/:event_id/book/:travel_date_id",
        name: "BookNow",
        component: () => import(/* webpackChunkName: "book" */ "@/views/BookNow"),
        meta: {
            requiresAuth: true,
            title: "Book Now - Soca Islands",
        },
    },
    {
        path: "/travel-dates/:event_id",
        name: "TravelDates",
        component: () => import(/* webpackChunkName: "book" */ "@/views/TravelDates"),
        meta: {
            requiresAuth: false,
            title: "Travel Dates - Soca Islands",
        },
    },
    {
        path: "/bookings",
        name: "Bookings",
        component: () => import(/* webpackChunkName: "bookings" */ "@/views/Bookings"),
        meta: {
            requiresAuth: true,
            title: "My Bookings - Soca Islands",
        },
    },
    {
        path: "/back-office",
        name: "Backoffice",
        component: () => import(/* webpackChunkName: "bookings" */ "@/views/BackOffice"),
        meta: {
            requiresAuth: true,
            title: "My Bookings - Soca Islands",
        },
    },
    {
        path: "/profile",
        name: "Profile",
        component: () => import(/* webpackChunkName: "profile" */ "@/views/Profile"),
        meta: {
            requiresAuth: true,
            title: "My Profile - Soca Islands",
        },
    },
    {
        path: "/login",
        name: "Login",
        component: () => import(/* webpackChunkName: "auth" */ "@/views/Login"),
        meta: {
            requiresAuth: false,
            title: "Login - Soca Islands",
        },
    },
    {
        path: "/forgot-password",
        name: "ForgotPassword",
        component: () => import(/* webpackChunkName: "auth" */ "@/views/ForgotPassword"),
        meta: {
            requiresAuth: false,
            title: "Forgot Password - Soca Islands",
        },
    },
    {
        path: "/reset-password",
        name: "ResetPassword",
        component: () => import(/* webpackChunkName: "auth" */ "@/views/ResetPassword"),
        meta: {
            requiresAuth: false,
            title: "Reset Your Password - Soca Islands",
        },
    },
    {
        path: "/auth",
        name: "Auth",
        component: () => import(/* webpackChunkName: "auth" */ "@/views/Auth"),
        meta: {
            requiresAuth: false,
            title: "Reset Your Password - Soca Islands",
        },
    },
    {
        path: "/signup",
        name: "Signup",
        component: () => import(/* webpackChunkName: "auth" */ "@/views/Signup"),
        meta: {
            requiresAuth: false,
            title: "Create a Soca Islands Account",
        },
    },
    {
        path: "/messages",
        name: "AppMessages",
        component: () => import(/* webpackChunkName: "messages" */ "@/views/AppMessages"),
        meta: {
            requiresAuth: true,
            title: "Messages - Soca Islands",
        },
    },
    {
        path: "/notifications",
        name: "Nofifications",
        component: () => import(/* webpackChunkName: "notifications" */ "@/views/AppMessages"),
        meta: {
            requiresAuth: true,
            title: "Notifications - Soca Islands",
        },
    },
    {
        path: "/destinations/:destination_id",
        name: "Destinations",
        component: () => import(/* webpackChunkName: "experience" */ "@/views/Destinations"),
        meta: {
            requiresAuth: false,
            title: "Destinations - Soca Islands",
        },
    },
    {
        path: "/:trip_category",
        name: "TripCategory",
        component: () => import(/* webpackChunkName: "experience" */ "@/views/TripCategory"),
        meta: {
            requiresAuth: false,
            title: "Experience - Soca Islands",
        },
    },
    {
        path: "/:trip_category/:trip_id",
        name: "Trip",
        component: () => import(/* webpackChunkName: "experience" */ "@/views/Trip"),
        meta: {
            requiresAuth: false,
            title: "Soca Islands",
        },
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0, behavior: "auto" };
        }
    },
    linkActiveClass: "mobile-menu-link-active",
});

// Retired 10 Oct 2026: customers use mytrips.socaislands.com now. Only the
// back office stays here, with the sign-in pages it needs; every other route
// shows a short "we've moved" page that takes them to the new portal.
const KEPT = /^\/(back-office|login|forgot-password|reset-password|auth|moved)(\/|$)/;

router.beforeEach((to, from, next) => {
    if (!KEPT.test(to.path)) {
        return next({ name: "Moved", replace: true });
    }
    const requiresAuth = to.matched.some((x) => x.meta.requiresAuth);
    const auth = getAuth();
    const currentUser = auth.currentUser;
    const windowTitle = to.meta?.title ? to.meta.title : "Soca Islands";

    window.document.title = windowTitle;

    if (requiresAuth && !currentUser) {
        next("/login?from=" + to.path);
    } else if (requiresAuth && currentUser) {
        next();
    } else {
        next();
    }
});

export default router;
